

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-beaver/dist/logger', 'components/xo-return-to-merchant/dist/util'], function ($, ng, squid, template) {

    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {

        return {
            template: template,
            controller: function controller($rootScope, $scope, $populate, $logger, $CheckoutAppDataModel, $CheckoutSessionModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window) {

                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
                $scope.locale = $locale;

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {

                    return $populate($scope, {
                        merchantPreferenceModel: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
                    }).then(function () {
                        // Show auto return page when feature is enabled by merchant and txn
                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
                        // Set content key based on device
                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
                        $scope.formattedAmount = squid.formatCurrency(amount, code);
                    });
                }).then(function () {
                    $('#outerWrapper').addClass('xo-done');

                    $scope.expansion = false;
                    $scope.toggle = function () {
                        if ($scope.expansion === false) {
                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                            $scope.expansion = true;
                        } else {
                            $scope.expansion = false;
                        }
                        return $scope.expansion;
                    };

                    $scope.autoReturnStatementClick = function (event) {
                        event.preventDefault();
                        if (event.target && event.target.nodeName === 'A') {
                            $scope.returnToMerchant();
                        }
                    };

                    if ($scope.isAutoReturn) {
                        $logger.info('autoreturn_to_merchant', {});
                        $window.setTimeout($scope.returnToMerchant, 3000);
                    }
                });

                $scope.returnToMerchant = function () {
                    return $state.go('checkout.end');
                };

                $rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        $('#outerWrapper').removeClass('xo-done');
                    }
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-page-components/src/done/directive.js
 ** module id = 379
 ** module chunks = 1
 **/